import { ContactProps } from '@/models/Contact';

export function normalizeIdentityValue(value?: string | null): string {
  return (value ?? '').trim().toLowerCase();
}

function getRelationshipSignature(contact: ContactProps): string {
  return (contact.contactRelationships ?? [])
    .map((relationship) => {
      return [
        relationship.applicationId,
        relationship.contactTypeId,
        normalizeIdentityValue(relationship.createdOnUTCDateTime),
      ].join('~');
    })
    .sort()
    .join('|');
}

export function getTrueDuplicateFingerprint(contact: ContactProps): string {
  const fields = [
    normalizeIdentityValue(contact.firstName),
    normalizeIdentityValue(contact.lastName),
    normalizeIdentityValue(contact.email),
    normalizeIdentityValue(contact.phone),
    normalizeIdentityValue(contact.title),
    normalizeIdentityValue(contact.departmentOther),
    normalizeIdentityValue(contact.streetAddress1),
    normalizeIdentityValue(contact.streetAddress2),
    normalizeIdentityValue(contact.city),
    normalizeIdentityValue(contact.zipCode),
    normalizeIdentityValue(contact.countyId != null ? contact.countyId.toString() : ''),
    normalizeIdentityValue(contact.stateId != null ? contact.stateId.toString() : ''),
    normalizeIdentityValue(contact.countryId != null ? contact.countryId.toString() : ''),
    normalizeIdentityValue(contact.linkedIn),
    normalizeIdentityValue(contact.whatsApp),
    normalizeIdentityValue(contact.certification),
    normalizeIdentityValue(
      contact.contactSubTypeId != null ? contact.contactSubTypeId.toString() : ''
    ),
    normalizeIdentityValue(
      contact.departmentTypeId != null ? contact.departmentTypeId.toString() : ''
    ),
    normalizeIdentityValue(
      contact.yearsExperience != null ? contact.yearsExperience.toString() : ''
    ),
    getRelationshipSignature(contact),
  ];
  return fields.join('||');
}

export function findExistingNameEmailMatch(
  contact: ContactProps,
  contacts: ContactProps[] | null | undefined
): ContactProps | null {
  const firstName = normalizeIdentityValue(contact.firstName);
  const lastName = normalizeIdentityValue(contact.lastName);
  const email = normalizeIdentityValue(contact.email);

  if (firstName.length === 0 || lastName.length === 0 || email.length === 0) {
    return null;
  }

  return (
    (contacts ?? []).find((existingContact) => {
      if (existingContact.id == null) {
        return false;
      }

      return (
        normalizeIdentityValue(existingContact.firstName) === firstName &&
        normalizeIdentityValue(existingContact.lastName) === lastName &&
        normalizeIdentityValue(existingContact.email) === email
      );
    }) ?? null
  );
}
